import { useEffect, useState } from "react";
import {
	ClockIcon,
	PencilSquareIcon,
	ExclamationTriangleIcon,
	NoSymbolIcon,
} from "@heroicons/react/24/outline";

export enum AutosaveStatus {
	Disabled,
	Waiting,
	Saving,
	Error,
}

export interface Props {
	status: AutosaveStatus;
	interval: number;
	onClick: (event: React.MouseEvent<SVGSVGElement>) => void;
	className: string;
}

export default function AutosaveMessage(props: Props) {
	const [delay, setDelay] = useState(false);

	useEffect(() => {
		if (props.status === AutosaveStatus.Saving) {
			setDelay(true);

			setTimeout(() => {
				setDelay(false);
			}, 1000 * 3);
		}
	}, [props.status]);

	return (
		<div className={props.className}>
			{props.status === AutosaveStatus.Waiting && !delay && (
				<>
					<ClockIcon
						className="inline h-6 w-6 mr-2"
						aria-hidden="true"
						onClick={props.onClick}
					/>
					Autosaves every {props.interval} seconds.
				</>
			)}
			{(props.status === AutosaveStatus.Saving || delay) && (
				<>
					<PencilSquareIcon className="inline h-6 w-6 mr-2" aria-hidden="true" />
					Saving...
				</>
			)}
			{props.status === AutosaveStatus.Error && (
				<>
					<ExclamationTriangleIcon className="inline h-6 w-6 mr-2" aria-hidden="true" />
					An error occurred while saving your work.
				</>
			)}
			{props.status === AutosaveStatus.Disabled && (
				<>
					<NoSymbolIcon className="inline h-6 w-6 mr-2" aria-hidden="true" />
					Autosave is disabled.
				</>
			)}
		</div>
	);
}
